import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { Booking } from "PFTypes";

import { useNotApplicable } from "./use_not_applicable";

type UseSortTitlesReturn = {
  sortTitles: (bookingA: Booking, bookingB: Booking) => number;
};

export const useSortTitles = (): UseSortTitlesReturn => {
  const { getCategory } = useBookingCategories();
  const NOT_APPLICABLE = useNotApplicable();

  const sortTitles = (bookingA: Booking, bookingB: Booking) => {
    const categoryA = getCategory(bookingA);
    const categoryB = getCategory(bookingB);

    const roleA = categoryA ? (bookingA.title ?? "") : NOT_APPLICABLE;
    const roleB = categoryB ? (bookingB.title ?? "") : NOT_APPLICABLE;

    return roleA.localeCompare(roleB);
  };

  return {
    sortTitles
  };
};
